<template>
  <div class="">
      
      <div class="text-white flex-1 col-span-1 border-0 rounded-t-xl">

        <div class="bg-theme-green px-4 py-2 text-white rounded-t-xl">
           <div class="flex justify-between items-center">
              <div class="flex justify-between flex-col h-full">
                <p class="font-medium leading-tight truncate text-single-line break-all text-2xl mt-0">{{ form.name.value }}</p>
                <p class="font-medium leading-tight truncate text-single-line break-all text-sm mt-[32px]">{{ form.code.value }}</p>
              </div>
              <div class="flex items-end">
                <button @click.prevent="update()" class="  tracking-widest cursor-pointer bg-white py-2 px-4 rounded text-theme-green hover:bg-theme-darkgreen hover:text-white mr-3">
                SAVE
              </button>
              <button @click.prevent="openDeleteConfirmModal()" class="cursor-pointer rounded-md bg-white text-theme-red py-2 px-4  hover:bg-theme-darkgreen hover:text-white mr-3">DELETE</button>
              <span @click.prevent="clearComponent" class="cursor-pointer rounded-md  text-white py-2 pl-1  hover:opacity-70">CLOSE</span>
                <!-- <mdicon name="close" size="32" class="flex justify-end cursor-pointer hover:opacity-60 mb-2"  @click="clearComponent" />
                <div class="flex justify-between">
                  <button @click="update()" class="h-10 hover:bg-theme-darkgreen border-0 hover:text-white rounded-md cursor-pointer text-green-400 bg-white py-2 px-4 uppercase font-semibold">Save</button>
                  <mdicon  @click="openDeleteConfirmModal()" name="trash-can-outline" class="hover:bg-theme-red hover:text-white del-icon border-0 rounded-md cursor-pointer text-theme-red bg-white ml-2 pt-2 py-1 px-1" /> -->
                <!-- </div> -->
              </div>
            </div>
        </div>

        <div class="pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-lg">
          <div class="flex xl:flex-row flex-col gap-3  mb-3">
            <div class="w-full xl:w-1/3">
               <div :class="'input-wrapper ' + (form.name.error_type)">
                  <label class="text-xs mb-1">Name:</label>
                  <input placeholder="Get Creative!" @keyup="validateFields(['name'])" v-model="form.name.value" class="block rounded bg-gray-black w-full" type="text" />
                  <p class="field-error label-text mt-1" v-if="form.name.error_message" v-text="form.name.error_message"></p>
              </div>
            </div>

            <div class="w-fill xl:w-1/3">
                <div :class="'input-wrapper ' + (form.code.error_type)">
                  <label class="text-xs mb-1">Tax Code:</label>
                  <input placeholder="GST" @keyup="validateFields(['code'])" v-model="form.code.value" class="block rounded bg-gray-black w-full" type="text" />
                  <p class="field-error label-text mt-1" v-if="form.code.error_message" v-text="form.code.error_message"></p>
                </div>
            </div>

            <div class="w-full xl:w-1/3">
              <div class="">
                <label class="text-xs mb-1">Status:</label>
                 <label class="flex  cursor-pointer">
                  <input type="checkbox" v-model="form.status" class="hidden peer">
                  <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (form.status ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
                  <span class="ml-2 text-white text-sm font-medium uppercase" :class="form.status ? 'text-theme-green' : 'text-[#F53333]'">{{form.status ? 'On' : 'Off'}}</span>
                </label>
              </div>
            </div>
          </div>

          <div class="flex xl:flex-row flex-col gap-3">
             <div class="w-full xl:w-1/3">
                <div :class="'input-wrapper ' + (form.taxRate.error_type)">
                  <label class="text-xs mb-1">Rate:</label>
                  <div class="block rounded bg-gray-black w-full relative">
                    <input  @keyup="validateFields(['taxRate'])" placeholder="Rate Amount" v-model="form.taxRate.value" class="bg-gray-black rounded  w-full pr-[100px]" type="number" />
                    <label class="flex items-center cursor-pointer absolute right-1 top-2">
                      <input type="checkbox" v-model="taxRateTypePercentage" class="hidden peer">
                      <div :class="'relative toggle-bg label-inside-switch border-2  h-6 w-11 rounded-full ' + (form.taxRateTypePercentage ? 'bg-theme-darkgreen border-theme-green' : 'bg-theme-darkgreen  border-theme-green')">
                        <span :class="'text-white ' + (taxRateTypePercentage ? 'left' : 'right')">{{taxRateTypePercentage ? '%' : '$'}}</span>
                      </div>
                    </label>
                  </div>
                   <p class="field-error label-text mt-1" v-if="form.taxRate.error_message" v-text="form.taxRate.error_message"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ReturnConfirmModal v-if="deleteObj.modal" :closeClick="closeDeleteModal" :actionClick="deleteLocationTax" :obj="deleteObj.obj" :heading="'You Are About To Delete ' + deleteObj.obj.name "/>
</template>


<script>
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions, mapMutations } from "vuex";
import BusinessTaxApis from "@/controllers/BusinessTaxApis";
import { useSnackbar } from "vue3-snackbar";
import Helpers from '@/helpers';
import ReturnConfirmModal from "@/components/general/dialog/ReturnConfirmModal.vue";
import CategorySelectCheckbox from '@/components/form/CategorySelectCheckbox.vue'
import BusinessProduct from '@/controllers/BusinessProductApis'

export default defineComponent({
  name: "AddLocationTax",
  components: {
    ReturnConfirmModal,
    CategorySelectCheckbox
  },
  setup() {
    const snackbar = useSnackbar();
    const deleteObj = ref({
      modal: false,
      obj: {},
    });
    const taxRateTypePercentage = ref(true);
    const categories = ref([])
    const form = ref({
      name: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required', 'min:3'],
      },
      code: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required', 'min:3'],
      },
      category: {
        value: [],
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      taxRate: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required', 'flat', 'maxval:100|when|taxRateType:percentage'],
      },
      taxType: 'primary',
      taxRateType: 'percentage',
      status: false,
    });
    return {
      form,
      snackbar,
      deleteObj,
      taxRateTypePercentage,
      categories
    };
  },
  props:{
    clearComponent: {
      type: Function,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },

  
  computed: {
    ...mapGetters({
      vg_locationSelected: "location/selected"
    }),
  },

  async mounted() {
    // this.getCategory()
    // this.getTaxCategory(this.item.id)
    this.assignItemValue();
  },

  watch: {
    'item'(val) {
      this.assignItemValue();
      // this.getTaxCategory(this.item.id)
    },
      // Fields cannot have white spaces
    'form.code.value'(val){
      this.form.code.value = val.replaceAll(/\s/g,'').trim();
    },
    'taxRateTypePercentage'(value) {
      this.form.taxRateType = value ? 'percentage' : 'flat';
      this.validateFields(['taxRate'])
    },

  },

  methods: {
    async getCategory(){
      let res = await BusinessProduct.fetchAllCategory()
      if(res.data?.payload?.category){
          for(let i=0; i<res.data.payload.category.length; i++){
              this.categories.push(res.data.payload.category[i])
              if(res.data.payload.category[i].subCategories && res.data.payload.category[i].subCategories.length>0){
                  for(let j=0; j<res.data.payload.category[i].subCategories.length; j++){
                      this.categories.push(res.data.payload.category[i].subCategories[j])
                  }
              }
          }
      }
    },
    async getTaxCategory(id){
      let res = await BusinessTaxApis.getTaxCategory(id, this.vg_locationSelected.id)
      if(res.status==200 && res.data.payload && res.data.payload.length>0){
        this.form.category.value = res.data.payload.map(each => each.id)
      }else{
        this.form.category.value = []
      }
    },
    assignItemValue() {
      this.form.name.value = this.item.name;
      this.form.code.value = this.item.code;
      this.form.taxType = 'primary';
      this.form.taxRate.value = this.item.taxRate;
      this.form.taxRateType = this.item.taxRateType;
       this.taxRateTypePercentage = this.item.taxRateType == 'percentage'  ? true : false;
      this.form.status = this.item.status;
    },
    
     /**
     * Validation captures
     */
    async validateFields(fields) {
      let res = await Helpers.validateFormFields(this.form, fields);
      // capture the fields
      this.form = res.data;
      return res.error ? false : true;
    },


    /**
     * Add new location Tax
     */
    async update() {
      let validate = await this.validateFields(['name', 'code', 'taxRate']);
      if(!validate) {
        return ;
      }
      this.va_spinner(true);
      let response = ''
      let res = await BusinessTaxApis.updateLocationTax(this.item.id, {
          name: this.form.name.value,
          code: this.form.code.value,
          taxType: this.form.taxType,
          taxRate: parseFloat(this.form.taxRate.value),
          taxRateType: this.taxRateTypePercentage ? 'percentage' : 'flat',
          status: this.form.status,
      });
      response = res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data)
      // if(this.form.category.value && this.form.category.value.length>0){
      //   res = await BusinessTaxApis.assignCategoryToTax(this.item.id, {locationId:this.vg_locationSelected.id, categoryIds: this.form.category.value})
      //   response = response+', '+(res.status <= 201 ?res.data.message : Helpers.catchErrorMessage(res.response.data))
      // }
      this.va_spinner(false);
      this.snackbar.add({
        type: 'info',
        text: response,
        duration: 3000,
      })
      if(res.status <= 201 ) {
        this.clearComponent();
        this.emitter.emit("refresh-business-tax-list", true);
      }
    },

    /**
     * Open delete confirm modal
     */
    async openDeleteConfirmModal() {
      this.deleteObj = {
        modal: true,
        obj: this.item,
      };
    },
    
    /**
     * Close delete confirm modal
     */
    closeDeleteModal() {
      this.deleteObj = {
        modal: false,
        obj: {},
      };
    },

    /**
     * Delete location 
     */
    async deleteLocationTax() {
      this.va_spinner(true);
      let res = await BusinessTaxApis.deleteBusinessTax(this.item.id);
      this.va_spinner(false);
        this.snackbar.add({
        type: 'info',
        text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
        duration: 3000,
      })
      if(res.status == 200 ) {
        this.clearComponent();
        this.emitter.emit("refresh-business-tax-list", true);
      }
    },

    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
});



</script>